<app-header-web (toggleChange)="toggleMenu()"></app-header-web>
<app-main-page [isExpanded]="isExpanded" [isloggedIn]="isLoggedIn">
  <div selector>
    @if (isLoggedIn) {
      <div class="page-container">
        <router-outlet></router-outlet>
      </div>
    }
    @if (!isLoggedIn) {
      <div class="notLogged">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</app-main-page>

<div class="card flex justify-content-center">
  <p-toast [position]="'top-center'"/>
</div>
